import { render, staticRenderFns } from "./LianXiWoMen.vue?vue&type=template&id=16d83842&scoped=true&"
import script from "./LianXiWoMen.vue?vue&type=script&lang=js&"
export * from "./LianXiWoMen.vue?vue&type=script&lang=js&"
import style0 from "./LianXiWoMen.vue?vue&type=style&index=0&id=16d83842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d83842",
  null
  
)

export default component.exports